import { Box, Grid, Modal, Button } from "@mui/material";
import { useState } from "react";
import { groupPendingMarkedPdfEvent } from "../../../../_events/orders/find_order.event";
import { message } from "antd";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalPendingPdf = () => {

    const [ info, setInfo ] = useState({ bytes: null, loading: false, open: false });

    const showModal = () => {
        setInfo({...info, loading: true, open: true});
        groupPendingMarkedPdfEvent()
        .then(json => {
            setInfo({
                ...info,
                bytes: json.data.bytes,
                loading: false,
                open: true
            });
        })
        .catch(err => {
            message.error(err.message);
            setInfo({
                ...info,
                loading: false
            });
        });
    }

    const handleClose = () => {
        setInfo({
            ...info,
            bytes: null,
            open: false
        });
    }

    return (
        <div>
            <Button variant='contained' onClick={() => showModal()}>PDF Pendientes</Button>
            <Modal
                open={info.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            {
                                info.loading ?
                                <>Cargando...</>
                                :
                                info.bytes &&
                                <div>
                                    <object width="100%" height="600px" 
                                        data={`data:application/pdf;base64,${info.bytes}`} 
                                        type="application/pdf" className="internal"
                                        >
                                        <embed 
                                            src={`data:application/pdf;base64,${info.bytes}`}
                                            type="application/pdf"
                                        />
                                    </object>
                                </div>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}

export default ModalPendingPdf;
